// Типы для управления заказами
import { z } from "zod";
import { zAddressDataSchema } from "../zAddressInfo";
import { zOrderCommonSchema, zOrderFiltersSchema, zPayerTypeSchema, } from "./order.common";
import { zDayjsSchema } from "../zDayjs";
// Информация об автомобиле клиента (из v_orders_list)
export const zOrderVehicleInfoSchema = z.object({
    // Поля из старых представлений (обратная совместимость)
    manufacturer: z.string().optional(),
    model: z.string().optional(),
    batteryCapacity: z.number().optional(),
    connectorType: z.string().optional(),
    // Поля из v_orders_list
    idVehicle: z.string().optional(),
    brand: z.string().optional(),
    stateNumber: z.string().optional(),
    dcPort: z.string().optional(),
});
// Order схема
export const zOrderSchemaDom = zOrderCommonSchema
    .omit({
    scheduledDate: true,
})
    .extend({
    addressInfo: zAddressDataSchema,
    scheduledDate: zDayjsSchema,
    vehicleInfo: zOrderVehicleInfoSchema.optional(),
    // FR-007: плательщик. payerType отсутствует у строк, созданных до выката
    // корп-схемы, — такая строка считается частной (UC-101 BR-9).
    payerType: zPayerTypeSchema.nullish(),
    corpCompanyId: z.string().nullish(),
    corpCompanyName: z.string().nullish(),
});
export const zOrderFiltersSchemaDom = zOrderFiltersSchema;
export const zCreateOrderSchemaDom = zOrderSchemaDom.omit({
    id: true,
    corpCompanyName: true,
    payerType: true,
});
